import { render } from "./info-box.component.vue?vue&type=template&id=1e6e9d0a&ts=true"
import script from "./info-box.component.vue?vue&type=script&lang=ts"
export * from "./info-box.component.vue?vue&type=script&lang=ts"

import "./info-box.component.vue?vue&type=style&index=0&id=1e6e9d0a&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__